import { Box,Typography } from "@mui/material"

interface Props{
    errorMessage:string;
}

const ErrorMessageComponent=({errorMessage}:Props)=>{
    return <Box sx={{mt:1,mb:1,display:errorMessage ? "block" : "none"}}>
        <Typography color="red">{errorMessage}</Typography>
    </Box>
}
export default ErrorMessageComponent;